import { render } from "./LivppyLab.vue?vue&type=template&id=2e1611ef&scoped=true"
import script from "./LivppyLab.vue?vue&type=script&lang=js"
export * from "./LivppyLab.vue?vue&type=script&lang=js"

import "./LivppyLab.vue?vue&type=style&index=0&id=2e1611ef&scoped=true&lang=css"

import exportComponent from "C:\\TK\\LivppyLab\\LivppyLab\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e1611ef"]])

export default __exports__